import React, { FC, useEffect } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import markerShadowPng from "leaflet/dist/images/marker-shadow.png";

const DefaultIcon = L.icon({
    iconUrl: markerIconPng,
    shadowUrl: markerShadowPng,
    iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

export interface ILocation {
    latitude: string;
    longitude: string;
    name: string;
    address: string;
}

interface IMapViewProps {
    data: ILocation[];
    selected?: ILocation | null;
}

const AutoFitBounds: FC<{ data: ILocation[] }> = ({ data }) => {
    const map = useMap();

    useEffect(() => {
        if (data.length > 0) {
            const bounds = L.latLngBounds(
                data.map((item) => [
                    parseFloat(item.latitude),
                    parseFloat(item.longitude),
                ])
            );
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [data, map]);

    return null;
};

const FlyToLocation: FC<{ location: ILocation | null }> = ({ location }) => {
    const map = useMap();

    useEffect(() => {
        if (location) {
            map.flyTo(
                [parseFloat(location.latitude), parseFloat(location.longitude)],
                16,
                { duration: 1.5 }
            );
        }
    }, [location, map]);

    return null;
};

export const MapView: FC<IMapViewProps> = ({ data, selected }) => {
    const center: [number, number] =
        data.length > 0
            ? [parseFloat(data[0].latitude), parseFloat(data[0].longitude)]
            : [0, 0];

    return (
        <MapContainer
            center={center}
            zoom={13}
            style={{ height: "300px", width: "100%", borderRadius: "10px" }}
        >
            <TileLayer
                attribution=""
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <AutoFitBounds data={data} />
            <FlyToLocation location={selected??null} />
            {data.map((location, idx) => {
                const pos: [number, number] = [
                    parseFloat(location.latitude),
                    parseFloat(location.longitude),
                ];
                return (
                    <Marker key={idx} position={pos}>
                        <Popup>
                            {location.name} <br />
                            {location.address}
                        </Popup>
                    </Marker>
                );
            })}
        </MapContainer>
    );
};
